import { render } from "./day-two-morning.vue?vue&type=template&id=07b3eeb0"
import script from "./day-two-morning.vue?vue&type=script&lang=js"
export * from "./day-two-morning.vue?vue&type=script&lang=js"
script.render = render

export default script